<template>
    <WLoading
        visible
        :opacity="1"
        position="absolute"
        :text="$t('general.exiting')"
        :style="{ top: 0, left: 0}"
    />
</template>

<script>
import {
    mapActions,
} from 'vuex'

export default {
    name: 'LogoutScreen',
    metaInfo () {
        return {
            title: this.$t('general.exiting'),
        }
    },
    created () {
        this.handleSignout()
    },
    methods: {
        ...mapActions({
            signout: 'auth/signout',
        }),
        async handleSignout () {
            try {
                await this.signout()
                this.$router.push({ name: 'Signin' })
            } catch (error) {
                console.info(error)
            }
        },
    },
}

</script>
